import { useState } from 'react';
import { DialogV2, AritoIcon, Button } from '@/components/custom/erp';
import { TaxGroup } from '@/types/schemas/nhom-thue.type';

interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  selectedObj: TaxGroup | null;
  deleteTaxGroup: (id: string) => Promise<void>;
  clearSelection: () => void;
}

const DeleteDialog = ({ open, onClose, selectedObj, deleteTaxGroup, clearSelection }: DeleteDialogProps) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async () => {
    if (!selectedObj) return;

    setIsDeleting(true);
    setError(null);

    try {
      await deleteTaxGroup(selectedObj.uuid);
      onClose();
      clearSelection();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Có lỗi xảy ra khi xóa nhóm thuế');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Xác nhận xóa'
      maxWidth='sm'
      disableBackdropClose={true}
      disableEscapeKeyDown={true}
    >
      <div className='p-4'>
        <p className='mb-4'>
          Bạn có chắc chắn muốn xóa nhóm thuế <strong>{selectedObj?.ten_phan_nhom}</strong> không?
        </p>

        {error && <div className='mb-4 rounded bg-red-100 p-2 text-red-700'>{error}</div>}

        <div className='flex justify-end gap-2'>
          <Button variant='destructive' onClick={handleDelete} disabled={isDeleting}>
            <AritoIcon icon={885} marginX='4px' />
            {isDeleting ? 'Đang xóa...' : 'Xóa'}
          </Button>
          <Button variant='outline' onClick={onClose} disabled={isDeleting}>
            <AritoIcon icon={889} marginX='4px' />
            Hủy
          </Button>
        </div>
      </div>
    </DialogV2>
  );
};

export default DeleteDialog;
